// Interruttore "Mostra avatar" del Profilo: salvato sul telefono (non sull'account), acceso di default.
// Spento = nelle liste niente avatar: corridori con la maglia della squadra (RiderFace), giocatori solo col nome
// (PersonAvatarFace, PersonAvatarBust, LeaderHero). Resta il proprio avatar in Home e nell'editor del Profilo.
// Serve ai telefoni lenti: con gli avatar spenti non si caricano i fogli dei livelli. Stessa idea di VB (lib/playerAvatarStore.js).
import { useSyncExternalStore } from 'react'
import { storage } from './storage'

const KEY = 'show_avatars'
let enabled = true
const listeners = new Set()
const emit = () => listeners.forEach((l) => l())

storage.get(KEY).then((v) => { if (v === '0') { enabled = false; emit() } }).catch(() => {})

export function setShowAvatars(value) {
  enabled = !!value
  emit()
  storage.set(KEY, value ? '1' : '0')
}

const subscribe = (cb) => { listeners.add(cb); return () => listeners.delete(cb) }
const get = () => enabled

export function useShowAvatars() {
  return useSyncExternalStore(subscribe, get, get)
}
